export default "__VITE_ASSET__DUlLkdeA__"